import { FIREBASE_STORAGE_URL } from "../../app-settings";
import { CardVariant } from "../../models/CardVariant"

export type CardImageProps = {
    className?: string | undefined,
    variant: CardVariant
}

export function CardImage(props: CardImageProps) {
    const defaultStyle = "h-full w-full object-contain object-center rounded-xl";
    return (
        <img
            src={`${FIREBASE_STORAGE_URL}/images/cards/${props.variant.imageId}.jpg`}
            alt={`${props.variant.card.name} ${props.variant.finish} ${props.variant.variant} image`}
            className={props.className ? props.className : defaultStyle} />
    )
}